import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {Link} from 'react-router-dom';
import {AddBusiness} from 'components/fair/fair-business';

export default class FairAddBusiness extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Thêm mới doanh nghiệp vào hội chợ</h1>
          </div>
          <AddBusiness match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-business/FairAddBusiness.jsx